(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heritage-variant-thumbnails"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-variant-thumbnails')) {
  customElements.define('ss-variant-thumbnails', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('a[data-variant-id]');
        if (!thumbnail || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const card = this.closest('.product-card-wrapper');
        const photo = card?.querySelector('.card__media img');
        if (!photo) return;
        event.preventDefault();
        photo.removeAttribute('srcset');
        photo.src = thumbnail.dataset.previewSrc;
        photo.alt = thumbnail.dataset.previewLabel;
        card.classList.add('ss-variant-preview');
        card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('variant', thumbnail.dataset.variantId);
          link.href = url.href;
        });
        this.querySelectorAll('[aria-current]').forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
        this.querySelector('[data-preview-announcement]').textContent = thumbnail.dataset.previewStatus;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
